import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/app/(main)/auth/layout.tsx from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(main)/auth/layout.tsx",
    "default",
);
